import * as queryString from 'query-string';
import { assign } from 'lodash';
import API from '../api';
import * as actions from '../constants';
import generateActions from './baseAction';

const {
  showError,
  clearErrors,
  getHolidays,
  getHoliday,
  addHoliday,
  updateHoliday,
  removeHoliday,
} = generateActions('holiday', 'holidays');

/**
 * Get a list of holidays in a range
 * @param {Date} start
 * @param {Date} end
 */
const getHolidayRange = (start, end): any => (
  (dispatch) => {
    dispatch({ start, end, type: actions.REQUEST_HOLIDAY_RANGE });
    return API.request(`/holidays/range?${queryString.stringify({
      start,
      end,
    })}`)
    .then(response => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_HOLIDAY_RANGE,
        data: response,
      });
      return response;
    })
    .catch((err) => {
      dispatch({
        type: actions.RECEIVE_HOLIDAY_RANGE,
        error: 'There was a problem fetching holidays',
      });
      return false;
    });
  }
);

export {
  showError,
  clearErrors,
  getHolidays,
  getHoliday,
  addHoliday,
  updateHoliday,
  removeHoliday,
  getHolidayRange,
};
